"use client";
import { useRouter } from "next/navigation";
import { TermsOfServicePage } from "@/components/termini-servizio/TermsOfServicePage";

export default function TerminiServizio() {
  const router = useRouter();
  return <TermsOfServicePage onBackToHome={() => router.push("/")} />;
}
